import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer as Drawer$1, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, SpaceSm, SpaceMd, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { XThin } from "@nxt-costco-com/forge-icons";
import { Text } from "../../DataDisplay/Text/index.js";
import { IconButton } from "../../Inputs/IconButton/index.js";
import { TITLE_ID, HEADER_ID, COMPONENT_NAME, CLOSE_BUTTON_ID } from "./constants.js";
import { getDataTestId } from "../../Util/index.js";
const StyledIconButton = styled(IconButton)`
    :focus-visible {
        outline: 2px solid Highlight;
        outline: 2px auto -webkit-focus-ring-color;
    }
    padding: ${SpaceXxs};
    z-index: 500;
`;
const CloseButton = ({ closeAriaLabel = "close", onClose }) => /* @__PURE__ */ jsx(
  StyledIconButton,
  {
    "aria-label": closeAriaLabel,
    "data-testid": CLOSE_BUTTON_ID,
    onClick: (e) => onClose == null ? void 0 : onClose(e, "escapeKeyDown"),
    children: /* @__PURE__ */ jsx(
      XThin,
      {
        sx: {
          width: "20px",
          height: "20px",
          color: ColorGray900
        }
      }
    )
  }
);
const Drawer = ({
  closeAriaLabel,
  title,
  titleBold,
  bodySx,
  headerSx,
  open,
  anchor,
  onClose,
  PaperProps,
  sx,
  id,
  ref,
  "aria-label": ariaLabel,
  children,
  uniqueId
}) => {
  return /* @__PURE__ */ jsx(
    Drawer$1,
    {
      PaperProps: {
        role: "dialog",
        "aria-modal": true,
        ...!title && { "aria-label": ariaLabel },
        ...!!title && { "aria-labelledby": TITLE_ID },
        ...PaperProps
      },
      open,
      anchor,
      onClose,
      sx,
      id,
      ref,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            width: "320px",
            bottom: "auto",
            height: "100vh"
          },
          children: [
            !!title && /* @__PURE__ */ jsxs(
              Box,
              {
                "data-testid": HEADER_ID,
                sx: [
                  {
                    display: "flex",
                    justifyContent: title ? "space-between" : "flex-end",
                    alignItems: "flex-start",
                    gap: SpaceMd,
                    margin: SpaceMd,
                    marginBottom: SpaceSm
                  },
                  ...Array.isArray(headerSx) ? headerSx : [headerSx]
                ],
                children: [
                  /* @__PURE__ */ jsx(Box, { sx: { paddingTop: "2px" }, children: /* @__PURE__ */ jsx(
                    Text,
                    {
                      component: "h2",
                      id: TITLE_ID,
                      variant: "t4",
                      bold: titleBold,
                      children: title
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    CloseButton,
                    {
                      closeAriaLabel,
                      onClose
                    }
                  )
                ]
              }
            ),
            !title && /* @__PURE__ */ jsx(
              Box,
              {
                sx: {
                  position: "absolute",
                  top: "0",
                  right: "0",
                  padding: SpaceMd
                },
                children: /* @__PURE__ */ jsx(
                  CloseButton,
                  {
                    closeAriaLabel,
                    onClose
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx(
              Box,
              {
                sx: [
                  {
                    margin: SpaceMd,
                    marginTop: title ? SpaceSm : SpaceMd
                  },
                  ...Array.isArray(bodySx) ? bodySx : [bodySx]
                ],
                children
              }
            )
          ]
        }
      )
    }
  );
};
Drawer.displayName = COMPONENT_NAME;
export {
  Drawer
};
